import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  return (
    <Card className="card" key={product._id}>
      <CardMedia image={product.image} component="img"  height="200" alt={product.name} />
      <CardContent>
        <Typography gutterBottom variant="h5" >
         {product.name}
        </Typography>
        <Typography style={{fontWeight:600}} variant="h6">
          {`$${product.cost}`}
        </Typography>
        <Rating value={product.rating} readOnly />
      </CardContent>
      <CardActions className="card-actions">
        <Button className="card-button" variant="contained" onClick={() => handleAddToCart(product)}><AddShoppingCartOutlined /> ADD TO CART</Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;
